import styled from 'styled-components';

export const StyledHeader = styled('header')`
  padding: 0.75rem 0 0.75rem;
  margin: 40px 140px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  .item {
    font-family: 'Graduate';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 21px;

    text-align: center;
    text-transform: uppercase;

    color: #ffffff;

    text-shadow: 0px 4px 4px #e02f29;

    cursor: pointer;
  }
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: -20px;

    img {
      max-width: 66px;
    }

    p {
      margin: 0;
      text-shadow: 0px 4px 4px #e02f29;
      font-size: 17px;
    }
  }
  @media only screen and (max-width: 920px) {
    display: none;
  }
`;

export const StyledTools = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 35px;
  margin-bottom: 40px;

  .handle-right {
    transform: rotate(180deg);
  }
  button {
    font-size: 12px;
    letter-spacing: 0;
    min-width: 155px;
    padding: 7px 10px;
  }
  .earning {
    font-size: 23px;
    max-width: 25%;
  }
`;

export const BarIcon = styled('div')`
  svg {
    fill: #fff;
    margin-top: 10px;
    margin-left: 10px;
  }
  display: none;
  @media only screen and (max-width: 920px) {
    display: block;
  }
`;
export const MobileLogo = styled('div')`
  text-align: center;
  display: none;
  p {
    font-size: 15px;
  }
  img {
    max-width: 55px;
  }
  @media only screen and (max-width: 920px) {
    display: block;
  }
`;
export const MobileMenu = styled('div')`
  height: 100%;
  position: fixed;
  left: -500%;
  transition: all 0.6s;
  top: 0;
  width: 100%;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  font-size: 35px;
  background: #00000073;
  backdrop-filter: blur(15px);
  font-weight: bold;
  a {
    color: red;
  }

  svg {
    position: absolute;
    right: 5%;
    top: 5%;
  }
`;
